import { connect } from "react-redux";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import moment from "moment";
import { useHistory } from "react-router";
import StatusLayout from "components/Status";

function ProjectAssignedManagement({ loggedUser, SetSelectedMenu, FetchDetails }) {
    const [list, setList] = useState([]);
    const [count, setCount] = useState(0);
    const history = useHistory();

    // useEffect(() => {
    //     SetSelectedMenu({
    //         menu: "project",
    //         title: "Project Assign Management",
    //     });
    // }, []);

    const columns = [
        {
            name: "code",
            label: "Code",
        },
        {
            name: "name",
            label: "Name",
        },
        {
            name: "startDate",
            label: "Start Date",
            options: {
                customBodyRender: (value) => moment(value).format("YYYY-MM-DD"),
            },
        },
        {
            name: "endDate",
            label: "End Date",
            options: {
                customBodyRender: (value) => moment(value).format("YYYY-MM-DD"),
            },
        },
        {
            name: "budget",
            label: "Budget",
        },
        {
            name: "impact",
            label: "Impact",
        },
        // {
        //     name: "program.name",
        //     label: "Program",
        // },
        {
            name: "performance",
            label: "Performance",
        },
        {
            name: "status",
            label: "Status",
            options: {
                customBodyRender: (value) => <StatusLayout status={value} />,
            },
        },

    ];
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        // setValue((v) => {
        //     v[name] = val;
        //     return { ...v };
        // });
    };
    return (
        <div className="w-full mb-12 px-4">
            <DatatableComponent
                columns={columns}
                title="Assigned Projects"
                viewColumns={false}
                search={false}
                // searchfield={true}

                url={`/api/project/assigned/${loggedUser?.Resource.id}?count=${count}`}
                processData={(data) => {
                    setList(data.projects);
                    return {
                        data: data.projects || [],
                        recordsFiltered: (data.projects || []).length,
                        page: 0,
                    };
                }}
                onRowClick={(data, { rowIndex }) => {
                    history.push(`/admin/project/details/${list[rowIndex].id}`);
                }}
                elevation={1}
            />
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectAssignedManagement);
